import { render, staticRenderFns } from "./WordPressInfo.vue?vue&type=template&id=a36d563a&"
import script from "./WordPressInfo.vue?vue&type=script&lang=js&"
export * from "./WordPressInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports